import { cn } from '@/lib/utils'

interface TourProgressProps {
  current: number
  total: number
  className?: string
  showNumbers?: boolean
}

export function TourProgress({ current, total, className, showNumbers = true }: TourProgressProps) {
  const percentage = Math.round((current / total) * 100)

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {showNumbers && (
        <span className='text-xs text-muted-foreground font-medium'>
          {current} of {total}
        </span>
      )}
      <div className='flex-1 bg-secondary rounded-full h-1.5 overflow-hidden'>
        <div className='h-full bg-primary transition-all duration-300 ease-out' style={{ width: `${percentage}%` }} />
      </div>
      {!showNumbers && <span className='text-xs text-muted-foreground font-medium'>{percentage}%</span>}
    </div>
  )
}
